/** Leaf SSOT — domain-specific workbench handler ref constants (no upstream workbench imports). */

export const COLLECTION_DOMAIN_HANDLER_REFS = {
  openContactFlow: 'collection:open_contact_flow',
  recordCommitment: 'collection:record_commitment',
} as const;

export const COLLECTION_DOMAIN_ACTION_IDS = {
  startCollectionContactFlow: 'start_collection_contact_flow',
  recordCollectionCommitment: 'record_collection_commitment',
} as const;

export const SUPPLIER_RECEIVING_DOMAIN_HANDLER_REFS = {
  openGoodsReceiptFlow: 'inventory:open_supplier_goods_receipt_flow',
} as const;

export const SUPPLIER_RECEIVING_DOMAIN_ACTION_IDS = {
  startSupplierGoodsReceiptFlow: 'start_supplier_goods_receipt_flow',
} as const;
